module.exports = __webpack_public_path__ + "static/media/2DGACM9.719f4441.jpg";